<template>
  <div class="table-custom" v-if="tableData.length">
    <table>
      <thead>
        <!-- categories header -->
        <tr class="categories-header-sis">
          <th
            class="p-4 student"
            :class="[item.count ? '' : 'w-12', index === 0 && 'sticky-avg']"
            v-for="(item, index) in headers"
            :key="item + index"
            :rowspan="item.count ? 1 : 2"
            :colspan="item.count || 1"
          >
            <div class="flex w-full">
              <div class="m-auto font-bold">
                {{ item.count ? item.name : $t("class." + item.name) }}
              </div>
            </div>
          </th>
        </tr>
        <!-- categories header -->

        <!-- activities header -->
        <tr class="activities-header-sis">
          <th
            class="p-2 min-w-[120px]"
            v-for="(column, index) in columns"
            :key="column + index"
          >
            <div
              v-if="isEditActivity"
              class="font-bold pl-3 pr-3"
              @click="showModalActivityDetail(column.name, index)"
            >
              <md-tooltip
                md-direction="top"
                :class="hiddenTooltip(column.name, subName(column.name, 15))"
                >{{ column.name }}
              </md-tooltip>
              <a class="cursor-pointer"> {{ subName(column.name, 15) }}</a>
            </div>
            <div v-else class="font-bold pl-3 pr-3">
              {{ column.name }}
            </div>
          </th>
        </tr>
        <!-- activities header -->

        <!-- Render Average row -->
        <tr class="bg-[#f1f1f1]">
          <td
            v-for="(field, indexField) in fixedFields"
            :key="indexField"
            class="bg-[#f1f1f1]"
            :class="{ 'sticky-avg': indexField === 0 }"
          >
            <div v-if="field === 'student'" class=" font-bold center-item">
              {{ $t("class.average") }}
            </div>
            <div class="data-table-cell-edit">
              <span
                class="font-bold"
                :class="{ 'center-item': field !== 'current_score' }"
                v-html="renderCell(avgScore[field])"
              ></span>
              <p>{{ field === "current_score" ? "%" : "" }}</p>
            </div>
          </td>
          <td v-for="(column, index) in columns" :key="column + index">
            <div
              class="data-table font-bold"
              v-html="
                renderCell(
                  avgScore['_' + column.name + '_' + column.category_id]
                )
              "
            ></div>
          </td>
        </tr>
        <!-- Render Average row -->
      </thead>
      <tr
        class="render-fixed-field"
        v-for="(item, index) in tableData"
        :key="item + index"
      >
        <!-- render fixed field -->
        <td v-for="(field, indexField) in fixedFields" :key="indexField">
          <span v-html="renderCell(item[field])"></span>
          <span>{{ field === "current_score" ? "%" : "" }}</span>
        </td>
        <!-- render fixed field -->

        <!-- render data -->
        <td v-for="(value, idx) in item.activities" :key="idx + value">
          <div class="data-table-cell-edit">
            <div>
              <input
                :class="getClassError(value.score, value.max_point)"
                type="number"
                v-model="value.score"
              />/
              <span class="max-point pr-3">{{ value.max_point }}</span>
            </div>
          </div>
        </td>
        <!-- render data -->
      </tr>
    </table>
  </div>
</template>

<script>
import { Class } from "@/constants/Permissions";
import { hasValidRole } from "@/helpers/role-helper";
import { mapGetters } from "vuex";
import Role from "@/constants/Role";

export default {
  name: "ScoreTable",
  props: [
    "columns",
    "headerColumns",
    "tableData",
    "avgScore",
    "status",
    "isLmsSystem",
    "lmsId"
  ],
  data() {
    return {
      modalEditActivity: {
        name: "",
        maxPoint: "",
        categoryId: ""
      },
      Class
    };
  },
  computed: {
    isShowFinalScoreAndGradeLetter() {
      return this.status === "Concluded";
    },
    headers() {
      if (this.isShowFinalScoreAndGradeLetter) {
        return this.headerColumns;
      }
      return this.headerColumns.filter(item => {
        return item.name !== "grade_letter" && item.name !== "final_score";
      });
    },
    fixedFields() {
      if (this.isShowFinalScoreAndGradeLetter) {
        return ["student", "final_score", "grade_letter", "current_score"];
      }
      return ["student", "current_score"];
    },
    ...mapGetters("user", {
      userRole: "role"
    }),
    isEditActivity() {
      return (
        this.$can(Class.actions.edit, Class.subject) ||
        hasValidRole(this.userRole, Role.Teacher)
      );
    }
  },
  methods: {
    getClassError(score, maxPoint) {
      return +score > +maxPoint ? "text-red-500" : "";
    },
    subName(name, maxLength) {
      if (name.length > maxLength) {
        return name.slice(0, 10) + (name.length > maxLength ? "..." : "");
      }
      return name;
    },
    hiddenTooltip(oldName, newName) {
      return oldName === newName ? "hidden-tooltip" : "";
    },
    showModalActivityDetail(name, index) {
      this.modalEditActivity.name = name;
      const cellInfo = this.tableData[0].activities[index];
      this.modalEditActivity.categoryId = cellInfo.category_id;
      this.modalEditActivity.maxPoint = cellInfo.max_point;
      this.$emit("editActivityData", this.modalEditActivity);
    },
    renderCell(value) {
      if (value instanceof Array) return cellVal.join(", ");
      const score = +value > 0 ? (+value).toFixed(2) : value;
      return score;
    }
  }
};
</script>
<style lang="scss" scoped>
.table-custom {
  overflow: scroll;
  max-height: 750px;
  table {
    min-width: 100%;
    thead {
      position: sticky;
      top: 0;
      z-index: 2;
      th:nth-child(1).student {
        min-width: 250px;
        left: 0;
        width: 25%;
        position: sticky;
        div {
          width: 100%;
          text-overflow: ellipsis;
        }
      }
      td:nth-child(1) {
        min-width: 250px;
        left: 0;
        width: 25%;
        position: sticky;
        div {
          width: 100%;
          text-overflow: ellipsis;
        }
      }
    }
  }
  table,
  td,
  th {
    table-layout: fixed;
    box-shadow: 0 0 0 0.6px black inset;
    text-align: center;
  }
  th {
    top: 0;
    z-index: 2;
    background: #f1f1f1;
    padding: 0;
  }
  .render-fixed-field {
    td:nth-child(1) {
      min-width: 250px;
      left: 0;
      width: 25%;
      position: sticky;
      background: #ffffff;
      div {
        width: 100%;
        text-overflow: ellipsis;
      }
    }
  }

  .border-bottom-none {
    border-bottom: none;
  }
  .border-top-none {
    border-top: none;
  }
  .data-table {
    justify-content: center;
  }
  .data-table-cell-edit {
    display: flex;
    justify-content: center;
    input {
      text-align: right;
      max-width: 38px;
    }
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    input[type="number"] {
      -moz-appearance: textfield;
    }
  }
  .font-bold {
    font-weight: 500 !important;
    font-size: 1rem;
    display: flex;
    justify-content: center;
  }
}
@media (max-width: 599px) {
  .render-fixed-field {
    td:nth-child(1) {
      position: static !important;
    }
  }
  .table-custom {
    table {
      td:nth-child(1) {
        position: static !important;
      }
      thead {
        position: static !important;
        th:nth-child(1).student {
          position: static !important;
        }
        td:nth-child(1) {
          position: static !important;
        }
      }
    }
  }
}
.center-item {
  display: flex;
  width: 50%;
  margin: auto;
}
.hidden-tooltip {
  display: none;
}
::-webkit-scrollbar {
  appearance: none;
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 25px;
}
</style>
